$.fn.inlineConfirm = function(options) {
  options = $.extend({
    messageHtml: "Are you sure?",
    yesHtml: "YES",
    noHtml: "NO",
    timeout: 3000
  }, options);
  $(this).each(function(idx, btn) {
    var $btn, $confirmContainer, $container, $message, $noBtn, $viewport, $yesBtn, _data, buttonHeight, clone, float, reset, show, timeoutTracker, topAmount;
    $btn = $(btn);
    $container = $("<div class='inline-confirm'>" + "<div class='viewport'>" + "<div class='confirmation-container'>" + "<span class='message'>Are you sure?</span>" + "<button class='btn btn-default no'></button>" + "<button class='yes'></button>" + "</div>" + "</div>" + "</div>");
    $viewport = $container.find(".viewport");
    $confirmContainer = $container.find(".confirmation-container");
    $message = $container.find(".message");
    $yesBtn = $container.find(".yes");
    $noBtn = $container.find(".no");
    timeoutTracker = null;
    $message.html(options.messageHtml);
    $yesBtn.html(options.yesHtml);
    $noBtn.html(options.noHtml);
    float = $btn.css("float");
    $btn.attr("class").split(" ").forEach(function(c) {
      if (c.indexOf("btn") !== 0) {
        $container.addClass(c);
        return $btn.removeClass(c);
      } else {
        return $yesBtn.addClass(c);
      }
    });
    $btn.css("float", float);
    $btn.addClass("original-button");
    $confirmContainer.css("float", float);
    clone = $btn.clone().css({
      'position': 'absolute',
      'left': '-999999px'
    }).show().attr({
      'aria-hidden': 'true'
    });
    clone.appendTo($("body"));
    buttonHeight = clone.innerHeight();
    clone.remove();
    topAmount = (buttonHeight * -1) + -5;
    $container.height(buttonHeight);
    $container.insertBefore($btn);
    $btn.insertBefore($confirmContainer);
    reset = function(event) {
      if (event) {
        event.preventDefault();
      }
      $btn.animate({
        opacity: 1
      }, 100);
      $confirmContainer.animate({
        opacity: 0
      }, 200);
      $viewport.animate({
        top: 0
      }, 200);
      if (timeoutTracker) {
        return window.clearTimeout(timeoutTracker);
      }
    };
    show = function(event) {
      if (event) {
        event.preventDefault();
      }
      $btn.animate({
        opacity: 0
      }, 200);
      $confirmContainer.animate({
        opacity: 1
      }, 200);
      return $viewport.animate({
        top: topAmount
      }, 200);
    };
    $confirmContainer.hover(function() {
      if (timeoutTracker) {
        return window.clearTimeout(timeoutTracker);
      }
    }, function() {
      return timeoutTracker = window.setTimeout(reset, options.timeout);
    });
    _data = $._data($btn[0], "events");
    if (_data) {
      _data.click.forEach(function(c) {
        $yesBtn.on("click", c.handler);
      });
    }
    $yesBtn.on("click", reset);
    $noBtn.on("click", reset);
    $btn.off("click");
    $btn.on("click", function(event) {
      event.preventDefault();
      return show();
    });
  });
  return $(this);
};
